import request from '../request'

// MF-67 — Journal templates API (Maestro-managed entry types).
export const getTemplates = (params = {}) => request.get('/journal/templates', { params }).then((res) => res)

export const getTemplate = (templateId = '') =>
  request.get(`/journal/templates/${templateId}`).then((res) => res)

export const createTemplate = (data = {}) => request.post('/journal/templates', data).then((res) => res)

export const updateTemplate = (templateId = '', data = {}) =>
  request.put(`/journal/templates/${templateId}`, data).then((res) => res)

export const deleteTemplate = (templateId = '') =>
  request.delete(`/journal/templates/${templateId}`).then((res) => res)
